let Main = ()=>import('../views/Main.vue')
export default[
    // 运营管理
    // {
    //     path:'operatemant',
    //     name:'operatemant',
    //     component:Main,
    //     meta:{
    //         title:'运营管理',
    //         icon:'icon-yunying'
    //     },
    //     children:[
    //         {
    //             path:'comment',
    //             name:'comment',               
    //             meta:{
    //                 title:'评论管理',
    //             },
    //             component:()=>import('@/views/operateMant/Comment.vue')
    //          },
    //          {
    //              path:'order',
    //              name:'order',
    //              meta:{
    //                 title:'订单管理',
    //              },
    //              component:()=>import('@/views/operateMant/Order')
    //          },
    //          {
    //              path:'freight',
    //              name:'freight',                
    //              meta:{
    //                 title:'运费管理',
    //             },
    //              component:()=>import('@/views/operateMant/Freight')
    //          },
    //     ]
    //  },
]